import create from 'zustand';

import { useAuthStore } from '../auth/auth';
import { LayoutType } from '../../types/LayoutType';
import { FindLayout } from '../../api/layout/findLayout';

interface FindLayoutsStore {
    FoundLayouts: LayoutType[];
    layout: LayoutType;
    fetchFoundLayouts: (layoutName: string) => any; // Добавьте layoutName как аргумент
}

export const useFindLayoutsStore = create<FindLayoutsStore>((set) => ({
    FoundLayouts: [],
    layout: {
        id: 0,
        uid: '',
        name: '',
        description: '',
        userUID: '',
        userName: '',
        viewType: '',
        devices: [],
    },
    fetchFoundLayouts: async (layoutName: string) => {
        // Добавьте layoutName как аргумент

        const { SmartDVRToken, user } = useAuthStore.getState();

        if (!user || !SmartDVRToken) {
            console.error('User or token information is missing.');
            return;
        }

        try {
            const data = { name: layoutName }; // Создайте объект data с именем раскладки
            const response = await FindLayout(SmartDVRToken, user.login, data); // Передайте третий аргумент data
            console.log(response);
            const updatedLayout = response?.data?.[0] || null;

            set({ FoundLayouts: response || [], layout: updatedLayout });
            return updatedLayout;
        } catch (error) {
            console.error('Error fetching layouts:', error);
        }
    },
}));
